import React from "react";
import "./styles.less";
import PageTitle from "../../components/page-title/PageTitle";
import { useTranslation } from "react-i18next";
import { partners } from "./content";
import PartnersListItem from "./PartnersListItem";

interface Props {
  withBackground?: boolean;
}

const PartnersPageList = ({ withBackground = false }: Props) => {
  const { t } = useTranslation();

  return (
    <article className={`partners-inline-page ${withBackground ? "partners-inline-page--with-background" : ""}`}>
      <section className="partners-inline-list">
        <h2 className="partners-inline-list__title">LJA „Šešėliavimas“ partneriai:</h2>

        <div className="partners-inline-list__items">
          {partners.map((partner) => (
            <PartnersListItem key={partner.title} partner={partner} />
          ))}
        </div>
      </section>
    </article>
  );
};

export default PartnersPageList;
